import React from 'react';

const InstantMeetingIcon = (props) => {
  let fill = props.fill ? props.fill : '#000';
  let fillOpacity = props.fill ? 1 : 0.38;

  return (
    <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M55.8578 49.34C55.1157 49.34 54.3991 49.1092 53.8358 48.6897L46.9628 43.8009C45.5906 42.8248 44.7757 41.2451 44.7757 39.5612V30.7395C44.7757 29.0556 45.5906 27.4759 46.9628 26.4998L53.8358 21.611C54.3991 21.1915 55.1157 20.9608 55.8578 20.9608C57.5733 20.9608 58.9653 22.17 58.9653 23.6631V46.6389C58.9653 48.1307 57.5747 49.34 55.8578 49.34Z"
        fill={fill}
      />
      <path
        d="M42.4105 41.5357C42.4105 45.8459 38.9164 49.34 34.6062 49.34H14.7408C10.4306 49.34 6.93652 45.8459 6.93652 41.5357V28.765C6.93652 24.4548 10.4306 20.9608 14.7408 20.9608H34.6062C38.9164 20.9608 42.4105 24.4548 42.4105 28.765V41.5357Z"
        fill={fill}
      />
    </svg>
  );
};

export default InstantMeetingIcon;
